import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import { SidePanel, SidePanelContent, SidePanelFooter } from '@securspace/securspace-ui-kit';
import { Link } from 'react-router';
import { styled } from '@mui/material/styles';
import RentalAgreementCheckbox from '../../../../RentalAgreementCheckbox';
import CancellationPolicy from '../../../../CancellationPolicy';
import Typography from '@mui/material/Typography';

const AcceptLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  fontSize: 'inherit',
  color: theme.palette.secondary.main,
}));

const StepLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1rem',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
}));

interface TermsAndConditionsPanelProps {
  open: boolean;
  onClose: () => void;
  completeBooking: () => void;
}

const TermsAndConditionsPanel = (props: TermsAndConditionsPanelProps) => {
  const { open, onClose, completeBooking } = props;
  const [agreementAccepted, setAgreementAccepted] = useState(false);

  const handleToggleAgreement = () => {
    setAgreementAccepted((prev) => !prev);
  };

  const handleClose = () => {
    setAgreementAccepted(false);
    onClose();
  };

  return (
    <SidePanel open={open} onClose={handleClose} title="Review Details">
      <SidePanelContent>
        <Grid container flexDirection="column" gap={2}>
          <StepLabel variant="subtitle1">
            Accept{' '}
            <AcceptLink to="/terms-of-use" target="_blank" rel="noopener noreferrer">
              Terms of Use
            </AcceptLink>{' '}
            Agreement:
          </StepLabel>
          <RentalAgreementCheckbox
            checked={agreementAccepted}
            onChange={handleToggleAgreement}
            required
          />
          <CancellationPolicy />
        </Grid>
      </SidePanelContent>
      <SidePanelFooter>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={4}>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              sx={{ py: 1.5, textTransform: 'none', fontSize: '1rem' }}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={8}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={completeBooking}
              disabled={!agreementAccepted}
              sx={{ py: 1.5, textTransform: 'none', fontSize: '1rem' }}
            >
              Next
            </Button>
          </Grid>
        </Grid>
      </SidePanelFooter>
    </SidePanel>
  );
};

export default TermsAndConditionsPanel;

